import moment from "moment";
import {
  GET_HOME_PAGE_TESTIMONIAL,
  SET_ORDER_BY,
  SET_PAGE,
  SET_SEARCH,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialHomeTestimonial = {
  homeTestimonial: [],
  homeTestimonialCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

const homeTestimonialReducer = (state = initialHomeTestimonial, action) => {
  switch (action.type) {
    case GET_HOME_PAGE_TESTIMONIAL:
      return {
        ...state,
        homeTestimonial: action.payload.homePageTestimonials.map(
          (testimonial) => {
            return {
              ...testimonial,

              updatedAtFormatted: moment(testimonial.createdAt).format("ll"),
            };
          }
        ),
        homeTestimonialCount: action.payload.totalCount,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };

    default:
      return state;
  }
};

export default homeTestimonialReducer;
